export default "__VITE_ASSET__JsZowJJ2__"